import { useEffect, useState } from "react";
import { useCareerDna } from "@/hooks/useCareerDna";
import { resolveCareerIds } from "@/lib/certifications";
import RecommendedCerts from "./RecommendedCerts";

/** Next Steps: certifications matched to the learner's top career matches. */
export default function NextStepCerts() {
  const { data: dna } = useCareerDna();
  const [ids, setIds] = useState<string[]>([]);
  useEffect(() => {
    if (dna?.matches?.length) resolveCareerIds(dna.matches).then(setIds).catch(() => setIds([]));
  }, [dna]);
  if (!ids.length) return null;
  return (
    <section aria-labelledby="ns-certs" className="space-y-3">
      <h2 id="ns-certs" className="font-display text-xl font-bold text-foreground">Certifications for your path</h2>
      <p className="text-sm text-muted-foreground">
        NSDC-approved credentials that line up with your Career DNA™ and your top matches. Start with a foundation one.
      </p>
      <RecommendedCerts ciIds={ids} recommended limit={4} />
    </section>
  );
}
